class INTENT.widgets.CreativeViewer

  @KEY_CODE_ESC: 27

  @OFFSET_HEIGHT: 200

  @CREATIVE_PREVIEW_URL: "#{preview_domain}/creative_preview"
  @CREATIVE_CLICK_URL: "#{preview_domain}/p/3click"
  @CREATIVE_3SERVE_URL: "px.adhigh.net/creative_preview"

  @FIELD_CODE_CAMPAIGN: 'cmp'
  @FIELD_CODE_CREATIVE: 'c'

  @SELECTER_LOCKER: "#screen-locker"

  @ATTR_NAME: "data-widget-creative-viewer"

  @ATTR_FIELD: "#{@ATTR_NAME}-field"
  @ATTR_FIELD_SIZE: "#{@ATTR_FIELD}-size"
  @ATTR_FIELD_NOSSL: "#{@ATTR_FIELD}-nossl"
  @ATTR_FIELD_TYPE: "#{@ATTR_FIELD}-type"
  @ATTR_FIELD_VIDEO_URL: "#{@ATTR_FIELD}-video-url"

  @ATTR_FIELD_SIZE_WIDTH: "#{@ATTR_FIELD_SIZE}-width"
  @ATTR_FIELD_SIZE_HEIGHT: "#{@ATTR_FIELD_SIZE}-height"

  @ATTR_HEADER: "#{@ATTR_NAME}-header"
  @ATTR_CONTENT: "#{@ATTR_NAME}-content"
  @ATTR_FOOTER: "#{@ATTR_NAME}-footer"

  @ATTR_CONTENT_CONTAINER: "#{@ATTR_CONTENT}-container"
  @ATTR_CREATIVE_URL_PREVIEW: "#{@ATTR_NAME}-creative-url-preview"
  @ATTR_CREATIVE_URL_CLICK: "#{@ATTR_NAME}-creative-url-click"
  @ATTR_CREATIVE_CODE: "#{@ATTR_NAME}-creative-code"

  @ATTR_BTN: "#{@ATTR_NAME}-btn"
  @ATTR_BTN_CLOSE: "#{@ATTR_BTN}-close"
  @ATTR_BTN_RELOAD: "#{@ATTR_BTN}-reload"

  @ATTR_AUTO_BINDER_PREVIEW: "data-preview-creative"
  @ATTR_ADVERTISER_ID: "data-preview-advertiser-id"
  @ATTR_PREVIEW_SIZE: "#{@ATTR_AUTO_BINDER_PREVIEW}-size"
  @ATTR_PREVIEW_NOSSL: "#{@ATTR_AUTO_BINDER_PREVIEW}-nossl"
  @ATTR_PREVIEW_TYPE: "#{@ATTR_AUTO_BINDER_PREVIEW}-type"
  @ATTR_PREVIEW_VIDEO_URL: "#{@ATTR_AUTO_BINDER_PREVIEW}-video-url"
  @ATTR_PREVIEW_SWF: "#{@ATTR_AUTO_BINDER_PREVIEW}-swf"
  @ATTR_PREVIEW_CAMPAIGNS_DATA: "#{@ATTR_AUTO_BINDER_PREVIEW}-campaigns-data"

  @ATTR_PREVIEW_ONE_CLICK: "#{@ATTR_AUTO_BINDER_PREVIEW}-click"

  @preview_url_state: 'initial'

  constructor: (@el) ->
    @s = @.constructor

    @locker = $ @s.SELECTER_LOCKER

    @header = @el.find "[#{@s.ATTR_HEADER}]"
    @content = @el.find "[#{@s.ATTR_CONTENT}]"
    @footer = @el.find "[#{@s.ATTR_FOOTER}]"

    @container = @content.find "[#{@s.ATTR_CONTENT_CONTAINER}]"

    @btn_close = @el.find "[#{@s.ATTR_BTN_CLOSE}]"
    @btn_reload = @el.find "[#{@s.ATTR_BTN_RELOAD}]"

    @size_width_field = @header.find "[#{@s.ATTR_FIELD_SIZE_WIDTH}]"
    @size_height_field = @header.find "[#{@s.ATTR_FIELD_SIZE_HEIGHT}]"
    @nossl_field = @header.find "[#{@s.ATTR_FIELD_NOSSL}]"
    @creative_type_field = @header.find "[#{@s.ATTR_FIELD_TYPE}]"
    @video_url_field = @header.find "[#{@s.ATTR_FIELD_VIDEO_URL}]"

    @campaign_field = @header.find "[#{@s.ATTR_FIELD}='#{@s.FIELD_CODE_CAMPAIGN}']"
    @creative_field = @header.find "[#{@s.ATTR_FIELD}='#{@s.FIELD_CODE_CREATIVE}']"

    @creative_url_preview = @el.find "[#{@s.ATTR_CREATIVE_URL_PREVIEW}]"
    @creative_url_click = @el.find "[#{@s.ATTR_CREATIVE_URL_CLICK}]"

    @creative_code = @el.find "[#{@s.ATTR_CREATIVE_CODE}]"

    @bind_close_action()
    @bind_preview_action()

    @el.on 'hidden.bs.modal', =>
      @s.preview_url_state = 'initial'
      @stopVideo()

  perform_window_size: () =>
    height = @get_height()
    window_height = $(window).height();

    if @get_creative_type() == 'native_creatives'
      max_height = parseFloat(window_height) - @s.OFFSET_HEIGHT
      @content.css 'max-height', max_height
    else
      @content.css 'max-height': 'auto'

  preview_creative: (creative_id, size, nossl, type, video_url) =>
    @prepare_form creative_id, size, nossl, type, video_url
    @render_preview()
    @el.find('iframe').trigger 'loading'
    @popup_display()

  set_creative_id: (creative_id) =>
    @creative_field.val creative_id

  get_creative_id: =>
    @creative_field.val()

  set_nossl_field: (nossl) =>
    @nossl_field.val(nossl)

  get_nossl_field: () =>
    @nossl_field.val() * 1

  get_creative_type: () =>
    @creative_type_field.val()

  set_creative_type: (type) =>
    @creative_type_field.val(type)

  get_video_url: () =>
    @video_url_field.val()

  set_video_url: (type) =>
    @video_url_field.val(type)

  preview_from_self: (self) =>
    id = self.attr @s.ATTR_AUTO_BINDER_PREVIEW
    advertiser_id = self.attr @s.ATTR_ADVERTISER_ID
    size = self.attr @s.ATTR_PREVIEW_SIZE
    nossl = self.attr @s.ATTR_PREVIEW_NOSSL
    type = self.attr @s.ATTR_PREVIEW_TYPE
    video_url = self.attr @s.ATTR_PREVIEW_VIDEO_URL
    is_swf = 1 * self.attr @s.ATTR_PREVIEW_SWF
    @campaign_field.html('')
    @campaign_field.attr('disabled', true)
    $.ajax({
      url: '/ajax/get_creative_campaigns',
      method: 'post',
      data: {creativeId: id, advertiserId: advertiser_id},
      success: (data, textStatus, jqXH) =>
        if jqXH.status is 200 and data.status
          campaignsData = data.msg
          if campaignsData
            optionsAsString = "<option value=''> — </option>"
            for group_i, group_row of campaignsData
              group_label = __('campaigns.off')
              group_label = __('campaigns.on') if (parseInt(group_i) == 1)
              optionsAsString += '<optgroup label="' + group_label + '">'

              for i, row of group_row
                optionsAsString += "<option value='" + i + "'> ["+i+"] " + escapeHtml(row.name) + "</option>" if !is_swf || !row.for_mobile_device

              optionsAsString += '</optgroup>'

            @campaign_field.html(optionsAsString)
            @campaign_field.removeAttr('disabled')
        else
          INTENT.utils.Notify.error __('general.ajax.error')
    })

    @preview_creative id, size, nossl, type, video_url

  bind_preview_action: () =>
    @campaign_field.on 'change', =>
      @s.preview_url_state = 'changed'
      @render_preview()

    @btn_reload.on 'click', =>
      @render_preview()

    $(document).on 'dblclick', "[#{@s.ATTR_AUTO_BINDER_PREVIEW}]:not([#{@s.ATTR_PREVIEW_ONE_CLICK}])", (e) =>
      self = $ e.currentTarget
      @locker.show()
      @preview_from_self self

    $(document).on 'click', "[#{@s.ATTR_PREVIEW_ONE_CLICK}]", (e) =>
      self = $ e.currentTarget
      @locker.show()
      @preview_from_self self

  bind_close_action: () =>
    @btn_close.on 'click', =>
      @popup_close()

    $(document).keyup (e) =>
      if e.keyCode == @s.KEY_CODE_ESC then @popup_close()

  get_iframe_html: (src, width, height) =>
    """
      <iframe src="#{src}" width="#{width}" height="#{height}" marginheight="0" marginwidth="0" frameborder="0" scrolling="no" style="overflow:hidden;"></iframe>
    """

  prepare_video_player: () =>
    setTimeout(
      () ->
        $('#video-popup').get(0).play()
      2000
    )

  render_preview: () =>
    src = @get_query_url()
    src_print = @get_print_query_url()
    src_click = @get_click_query_url()
    src_3serve = @get_3serve_query_url()
    width = @get_width()
    height = @get_height()

    @el.off 'hide.bs.modal'

    if @get_creative_type() == "video" || @get_creative_type() == "smart_tv"
      width = 640
      height = 320
      html = '<video id="video-popup" width="'+width+'" height="'+height+'" controls><source src="'+@get_video_url()+'"/></video>'
      @container.html html
    else if @get_nossl_field()
      html = '<p>' + __('creatives.nossl_link') + '</p><a target="preview" href="'+src+'">'+src+'</a>'
      @container.html html
    else if @get_creative_type() == "native_creatives"
      iframe_width = 400
      iframe_height = parseFloat($(window).height()) - 300
      if iframe_height < 500
        iframe_height = 500
      iframe = @get_iframe_html src, iframe_width, iframe_height
      @container.html iframe
    else
      iframe = @get_iframe_html src, width, height
      @container.html iframe

    if @creative_url_preview.length > 0
      @creative_url_preview.attr('href', src_print)

    if @creative_url_click.length > 0
      @creative_url_click.attr('href', src_click)

    if @creative_code.length > 0
      @creative_code.val "<iframe width='#{width}' height='#{height}' src='#{src_3serve}' frameborder='0' scrolling='no'>"

    @perform_window_size()

    if @get_creative_type() == "3rdparty_video" and not @get_nossl_field()
      @el.on 'hide.bs.modal', =>
        @container.find('iframe').remove()
      iframe = @get_iframe_html "#{@get_video_url()}", 640, 480
      @container.html iframe

    else if @get_creative_type() == "video" || @get_creative_type() == "smart_tv"
      @prepare_video_player()

    if @get_creative_type() != "3rdparty_video"
      @el.find('iframe').on 'load', =>
        @manage_iframe_loader on
      .on 'loading', =>
        @manage_iframe_loader()

  manage_iframe_loader: (remove) =>
    remove = remove or no
    if not $('#iframe-loader').length and not remove
      @container.append($ "<div id='iframe-loader' style='position:absolute;top:48%;left:48%;'><i class='fa fa-circle-o-notch fa-spin green'/></div>")
    else if remove
      $('#iframe-loader').remove()

  set_size: (size) =>
    size = size + ''
    size = size.split /x/i

    @size_width_field.val(size[0])
    @size_height_field.val(size[1])

  get_height: =>
    @size_height_field.val()

  get_width: =>
    @size_width_field.val()

  prepare_form: (creative_id, size, nossl, type, video_url) =>
    @set_size size
    @set_creative_id creative_id
    @set_nossl_field nossl
    @set_creative_type type
    @set_video_url video_url

    if @get_nossl_field()
      @btn_reload.hide()
    else
      @btn_reload.show()

  popup_display: () =>
    @el.modal('show')
    @locker.fadeOut()

  popup_close: () =>
    @container.find('iframe').remove()
    @stopVideo()
    @el.modal('hide')
    @locker.fadeOut()

  stopVideo: () =>
    video_popup = $('#video-popup')
    if video_popup.length
      video_popup.get(0).pause()
      video_popup.get(0).currentTime = 0

  get_query_url: () =>
    params = @get_values()

    query_string = ''
    for own key, value of params
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&"

    if query_string.length > 0
      query_string = '?' + query_string.substring(0, query_string.length-1)

    if @get_nossl_field()
      "http://" + @s.CREATIVE_PREVIEW_URL + "#{query_string}"
    else
      "//" + @s.CREATIVE_PREVIEW_URL + "#{query_string}"

  get_print_query_url: () =>
    params = @get_values()

    query_string = ''
    for own key, value of params
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&"

    if query_string.length > 0
      query_string = '?' + query_string.substring(0, query_string.length-1)

    if @get_nossl_field()
      "http://" + @s.CREATIVE_PREVIEW_URL + "#{query_string}"
    else
      "https://" + @s.CREATIVE_PREVIEW_URL + "#{query_string}"

  get_click_query_url: () =>
    params = @get_values()

    query_string = ''
    for own key, value of params
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&"

    if query_string.length > 0
      query_string = '?' + query_string.substring(0, query_string.length-1)

    if @get_nossl_field()
      "http://" + @s.CREATIVE_CLICK_URL + "#{query_string}"
    else
      "https://" + @s.CREATIVE_CLICK_URL + "#{query_string}"

  get_3serve_query_url: () =>
    params = @get_values()

    query_string = ''
    for own key, value of params
      query_string += encodeURIComponent(key) + "=" + encodeURIComponent(value) + "&"

    if query_string.length > 0
      query_string = '?' + query_string.substring(0, query_string.length-1)

    if @get_nossl_field()
      "http://" + @s.CREATIVE_3SERVE_URL + "#{query_string}"
    else
      "https://" + @s.CREATIVE_3SERVE_URL + "#{query_string}"

  get_values: (field_name = null) =>
    param_bag = {}

    field_attr = @s.ATTR_FIELD
    fields = @header.find "[#{field_attr}]"
    url_state = @s.preview_url_state

    fields.each ->
      self = $ @
      if self.val()
        key = self.attr(field_attr)
        if url_state == 'initial' and 'cmp' == key
          return
        val = self.val()
        param_bag[key] = val

    unless field_name then param_bag else param_bag[field_name]

